import { DefaultTheme, ThemeProps } from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getToken } from '@optimus-web/common';
import { TagVariant } from './types';

export type Variants = TagVariant;

interface TagProps {
    variant?: TagVariant;
}

export type ColorTokens<T extends string> = {
    [variant in T]: ((props: ThemeProps<DefaultTheme>) => string) | string;
};

export const getVariant = (props: ThemeProps<DefaultTheme> & TagProps) => {
    const variant: Variants = props?.variant || 'basicSubtle';

    return { variant };
};

export const getBackgroundColor = (props: ThemeProps<DefaultTheme>) => {
    const getBackgroundColorTokens: ColorTokens<Variants> = {
        tangerine: getToken(TokenName.LEGACY_SUPPORT_TAG_BACKGROUND_TANGERINE),
        mustard: getToken(TokenName.LEGACY_SUPPORT_TAG_BACKGROUND_MUSTARD),
        lime: getToken(TokenName.LEGACY_SUPPORT_TAG_BACKGROUND_LIME),
        lavender: getToken(TokenName.LEGACY_SUPPORT_TAG_BACKGROUND_LAVENDER),
        denim: getToken(TokenName.LEGACY_SUPPORT_TAG_BACKGROUND_DENIM),
        ruby: getToken(TokenName.LEGACY_SUPPORT_TAG_BACKGROUND_RUBY),
        basicBold: getToken(TokenName.LEGACY_SUPPORT_TAG_BACKGROUND_BASIC_BOLD),
        basicSubtle: getToken(TokenName.BACKGROUND_ALERT_BASIC_SECONDARY),
        primary: getToken(TokenName.LEGACY_SUPPORT_TAG_BACKGROUND_PRIMARY),
        info: getToken(TokenName.BACKGROUND_ALERT_INFO_SECONDARY),
        success: getToken(TokenName.BACKGROUND_ALERT_SUCCESS_SECONDARY),
        warning: getToken(TokenName.BACKGROUND_ALERT_WARNING_SECONDARY),
        danger: getToken(TokenName.BACKGROUND_ALERT_DANGER_SECONDARY),
    };

    const { variant } = getVariant(props);
    return getBackgroundColorTokens[variant];
};

export const getColor = (props: ThemeProps<DefaultTheme>) => {
    const getColorTokens: ColorTokens<Variants> = {
        tangerine: getToken(TokenName.LEGACY_SUPPORT_TAG_TEXT_TANGERINE),
        mustard: getToken(TokenName.LEGACY_SUPPORT_TAG_TEXT_MUSTARD),
        lime: getToken(TokenName.LEGACY_SUPPORT_TAG_TEXT_LIME),
        lavender: getToken(TokenName.LEGACY_SUPPORT_TAG_TEXT_LAVENDER),
        denim: getToken(TokenName.LEGACY_SUPPORT_TAG_TEXT_DENIM),
        ruby: getToken(TokenName.LEGACY_SUPPORT_TAG_TEXT_RUBY),
        basicBold: getToken(TokenName.LEGACY_SUPPORT_TAG_TEXT_BASIC_BOLD),
        basicSubtle: getToken(TokenName.TEXT_ALERT_BASIC),
        primary: getToken(TokenName.LEGACY_SUPPORT_TAG_TEXT_PRIMARY),
        info: getToken(TokenName.TEXT_ALERT_INFO),
        success: getToken(TokenName.TEXT_ALERT_SUCCESS),
        warning: getToken(TokenName.TEXT_ALERT_WARNING),
        danger: getToken(TokenName.TEXT_ALERT_DANGER),
    };

    const { variant } = getVariant(props);
    return getColorTokens[variant];
};

export const getBorderColor = (props: ThemeProps<DefaultTheme>) => {
    const getBorderTokens: ColorTokens<Variants> = {
        tangerine: getToken(TokenName.LEGACY_SUPPORT_TAG_BORDER_TANGERINE),
        mustard: getToken(TokenName.LEGACY_SUPPORT_TAG_BORDER_MUSTARD),
        lime: getToken(TokenName.LEGACY_SUPPORT_TAG_BORDER_LIME),
        lavender: getToken(TokenName.LEGACY_SUPPORT_TAG_BORDER_LAVENDER),
        denim: getToken(TokenName.LEGACY_SUPPORT_TAG_BORDER_DENIM),
        ruby: getToken(TokenName.LEGACY_SUPPORT_TAG_BORDER_RUBY),
        basicBold: getToken(TokenName.LEGACY_SUPPORT_TAG_BORDER_BASIC_BOLD),
        basicSubtle: getToken(TokenName.BORDER_ALERT_BASIC),
        primary: getToken(TokenName.LEGACY_SUPPORT_TAG_BORDER_PRIMARY),
        info: getToken(TokenName.BORDER_ALERT_INFO),
        success: getToken(TokenName.BORDER_ALERT_SUCCESS),
        warning: getToken(TokenName.BORDER_ALERT_WARNING),
        danger: getToken(TokenName.BORDER_ALERT_DANGER),
    };

    const { variant } = getVariant(props);
    return getBorderTokens[variant];
};
